import { Component, Inject, Optional } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { AddDeliveryPartnerComponent } from '../add-delivery-partner/add-delivery-partner.component';

@Component({
  selector: 'app-dimension-weight',
  templateUrl: './dimension-weight.component.html',
  styleUrls: ['./dimension-weight.component.scss']
})
export class DimensionWeightComponent {


  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  constructor(public dialogRef: MatDialogRef<AddDeliveryPartnerComponent>,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.initializeForm();
  }
  initializeForm() {
    let { Measurments } = this.props.item;
    this.form = this.fb.group({
      Weight: new FormControl(Measurments.Weight, Validators.compose([Validators.required, Validators.min(1)])),
      Height: new FormControl(Measurments.Height, Validators.compose([Validators.required, Validators.min(1)])),
      Width: new FormControl(Measurments.Width, Validators.compose([Validators.required, Validators.min(1)])),
      Length: new FormControl(Measurments.Length, Validators.compose([Validators.required, Validators.min(1)])),
    });
  }
  formSubmit() {
    if (this.form.valid) {
      this.props.item.Measurments = this.form.value;
      this.dialogRef.close();
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

  validateInput(label:string){
    if (this.form.get('Weight')?.value < 0 && label == 'Weight') {
      this.form.get('Weight')?.setValue(0)
    }
    else if (this.form.get('Height')?.value < 0 && label == 'Height') {
      this.form.get('Height')?.setValue(0)
    }
    else if (this.form.get('Width')?.value < 0 && label == 'Width') {
      this.form.get('Width')?.setValue(0)
    }
    else if (this.form.get('Length')?.value < 0 && label == 'Length') {
      this.form.get('Length')?.setValue(0)
    }
  }

}
